var newIncident = (function () {
    // Action Nav Event Handler
    function handleActionNavEvent(target) {
        var targetAction = target.dataset.actionNav;

        switch (targetAction) {
            case 'miniRosterDone': {
                var selectedConsumers = roster2.getActiveConsumers();
                itConsumerSection.addConsumers(selectedConsumers);
                DOM.toggleNavLayout();
                break;
            }
            case 'miniRosterCancel': {
                DOM.toggleNavLayout();
                break;
            }
        }
    }

    function loadPage(consumer) {
        DOM.clearActionCenter();
        if (!consumer) return; 
        roster2.setAllowedConsumers(['%']);
        roster2.miniRosterinit();
          
        var newIncidentCard = incidentCard.build(null, consumer);

        DOM.ACTIONCENTER.appendChild(newIncidentCard);

        DOM.autosizeTextarea();
    }

    function init(consumer) {
        if (!consumer) return; 
        setActiveModuleSectionAttribute('incidentTracking-new');
        loadPage(consumer);
    }

    return {
        handleActionNavEvent,
        init
    }
})();
